import "./OneTimeUseShell.css";

export function OneTimeUseTop(props: {
  staticPuzDir: string;
  left: number;
  right: number;
}) {
  // sorry i swapped left and right visually
  return (
    <div className="onetime-use onetime-card-top">
      <span>{props.left}</span>
      <div>{" _".repeat(props.right).slice(1)}</div>
      <img src={`${props.staticPuzDir}/default/art.png`} />
      <img src={`${props.staticPuzDir}/default/top.png`} />
    </div>
  );
}

export function OneTimeUseBottom(props: {
  staticPuzDir: string;
  rules: string;
  left: number;
  right: number;
}) {
  return (
    <div className="onetime-use onetime-card-bottom">
      <img src={`${props.staticPuzDir}/default.png`} />
      <div className="onetime-card-mid">{props.rules}</div>
      <div className="onetime-card-last">
        ‰ +{" "}
        <div className="onetime-card-circle-wrapper">
          <span className="onetime-card-circle"></span>
        </div>{" "}
        mod {props.left} ({props.right})
      </div>
    </div>
  );
}

export function OneTimeUseAll(props: {
  staticPuzDir: string;
  left: string;
  right: string;
}) {
  return (
    <div
      className="onetime-use onetime-card-all"
      style={{
        background: `url("${props.staticPuzDir}/default.png")`,
        backgroundSize: "100% 100%",
      }}
    >
      <header>Rules</header>
      <div className="onetime-card-left">{props.left}</div>
      <div className="onetime-card-right">{props.right}</div>
    </div>
  );
}
